"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isLoginAttemptsLimitExceeded = exports.removeExpiredLoginAttempts = exports.registerLoginAttempt = exports.removeLoginAttempts = exports.setLoginAttempt = exports.getLoginAttempts = void 0;
var redirect_1 = require("../../build-babel/redirect");
var localhost_1 = require("../../build-babel/redirect/localhost");
var LOGIN_ATTEMPTS_KEY = 'AUTH_LOGIN_ATTEMPTS';
var LOGIN_ATTEMPT_EXPIRATION_PERIOD_IN_MS = 10 * 1000; // 10 seconds
var LOGIN_ATTEMPTS_LIMIT = 3;
var LOGIN_LOCALHOST_ATTEMPTS_LIMIT = 4;
var getLoginAttempts = function getLoginAttempts() {
  var loginAttempts = sessionStorage.getItem(LOGIN_ATTEMPTS_KEY);
  return loginAttempts ? JSON.parse(loginAttempts) : [];
};
exports.getLoginAttempts = getLoginAttempts;
var setLoginAttempt = function setLoginAttempt(loginAttempt) {
  var loginAttempts = (0, exports.getLoginAttempts)();
  loginAttempts.push(loginAttempt);
  sessionStorage.setItem(LOGIN_ATTEMPTS_KEY, JSON.stringify(loginAttempts));
};
exports.setLoginAttempt = setLoginAttempt;
var removeLoginAttempts = function removeLoginAttempts() {
  sessionStorage.removeItem(LOGIN_ATTEMPTS_KEY);
};
exports.removeLoginAttempts = removeLoginAttempts;
var registerLoginAttempt = function registerLoginAttempt() {
  (0, exports.removeExpiredLoginAttempts)();
  var newLoginAttempt = {
    datetime: Date.now()
  };
  (0, exports.setLoginAttempt)(newLoginAttempt);
};
exports.registerLoginAttempt = registerLoginAttempt;
var removeExpiredLoginAttempts = function removeExpiredLoginAttempts() {
  var loginAttempts = JSON.parse(JSON.stringify((0, exports.getLoginAttempts)()));
  if (loginAttempts.length > 0) {
    (0, exports.removeLoginAttempts)();
    loginAttempts.filter(function (loginAttempt) {
      return Date.now() - loginAttempt.datetime < LOGIN_ATTEMPT_EXPIRATION_PERIOD_IN_MS;
    }).forEach(function (actualLoginAttempt) {
      return (0, exports.setLoginAttempt)(actualLoginAttempt);
    });
  }
};
exports.removeExpiredLoginAttempts = removeExpiredLoginAttempts;
var isLocalhostAttempt = function isLocalhostAttempt() {
  var redirectUrl = (0, redirect_1.getRedirectUrl)();
  return redirectUrl === null ? false : (0, localhost_1.isLocalhostRedirect)(redirectUrl);
};
var isLoginAttemptsLimitExceeded = function isLoginAttemptsLimitExceeded() {
  return isLocalhostAttempt() ? (0, exports.getLoginAttempts)().length >= LOGIN_LOCALHOST_ATTEMPTS_LIMIT : (0, exports.getLoginAttempts)().length >= LOGIN_ATTEMPTS_LIMIT;
};
exports.isLoginAttemptsLimitExceeded = isLoginAttemptsLimitExceeded;
//# sourceMappingURL=loginAttempts.js.map